import React from "react";
import { useSelector } from "react-redux";

const RoleSelector = ({ selected, onChange }) => {
  const roles = useSelector((state) => state.auth.roleList);

  const getRoleIcon = (roleName) => {
    switch (roleName?.toLowerCase()) {
      case "admin":
        return "admin_panel_settings";
      case "test officer":
        return "engineering";
      default:
        return "person";
    }
  };

  const isSingle = roles.length === 1;

  return (
    <div
      className={
        isSingle
          ? "flex justify-center"
          : "grid grid-cols-2 sm:grid-cols-3 gap-2.5 max-h-[200px] overflow-y-auto pr-1"
      }
    >
      {roles.map((role) => {
        const isActive = selected === role.RoleID;

        return (
          <button
            key={role.RoleID}
            type="button"
            title={role.RoleName}
            onClick={() => onChange(role.RoleID)}
            className={`flex items-center gap-2 px-3 py-2.5 rounded-xl border-2 text-left transition-all duration-150 min-w-0 ${
              isSingle ? "min-w-[180px] justify-center" : ""
            } ${
              isActive
                ? "border-primary bg-primary/5 text-primary shadow-sm"
                : "border-slate-200 bg-white text-slate-600 hover:border-primary/40 hover:bg-slate-50"
            }`}
          >
            <span
              className={`material-symbols-outlined text-[20px] flex-shrink-0 ${
                isActive ? "text-primary" : "text-slate-400"
              }`}
            >
              {getRoleIcon(role.RoleName)}
            </span>
            <span className="text-[11px] font-bold uppercase tracking-wide truncate flex-1">
              {role.RoleName}
            </span>
            {isActive && (
              <span className="material-symbols-outlined text-[16px] text-primary flex-shrink-0">
                check_circle
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default React.memo(RoleSelector);
